"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewForUserContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const NewForUserContainer = exports.NewForUserContainer = _styledComponents.default.div.withConfig({
  displayName: "NewForUserstyle__NewForUserContainer",
  componentId: "sc-jts83j-0"
})(["@keyframes grow{0%{transform:scale(1);}7.5%{transform:scale(1);}9.1875%{transform:scale(1.22);}10.875%{transform:scale(1);}12.5625%{transform:scale(1.22);}13.875%{transform:scale(1);}15.5625%{transform:scale(1.22);}16.875%{transform:scale(1);}100%{transform:scale(1);}}transform-origin:9px 16px;animation:10s ease-in-out 3s infinite grow;height:12px;width:12px;position:absolute;z-index:20;right:-0px;top:-10px;padding:4px;pointer-events:none;"]);